import { Instance } from 'mobx-state-tree';
import { ProjectRouteStopSchedulingDtoModelBase } from './ProjectRouteStopSchedulingDtoModel.base';

/* The TypeScript type of an instance of ProjectRouteStopSchedulingDtoModel */
export interface ProjectRouteStopSchedulingDtoModelType extends Instance<typeof ProjectRouteStopSchedulingDtoModel.Type> {}

/* A graphql query fragment builders for ProjectRouteStopSchedulingDtoModel */
export { selectFromProjectRouteStopSchedulingDto, projectRouteStopSchedulingDtoModelPrimitives, ProjectRouteStopSchedulingDtoModelSelector } from './ProjectRouteStopSchedulingDtoModel.base';

/**
 * ProjectRouteStopSchedulingDtoModel
 *
 * Route scheduling a stop
 */
export const ProjectRouteStopSchedulingDtoModel = ProjectRouteStopSchedulingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
